import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { Dispatch, SetStateAction } from 'react';
import { MyOrderListModel } from '../views/Marketplace/Maeketplace.types';

export const getOrders = createAsyncThunk('auth/getInvoices', async () => {
  const { data } = await axios.get(`/package/my-package`);

  return data.data.orders as MyOrderListModel[];
});

export const cancelOrder = createAsyncThunk(
  'auth/cancelOrder',
  async ({
    userPackage,
    setIsCancelModalOpen
  }: {
    userPackage: any;
    setIsCancelModalOpen: Dispatch<SetStateAction<boolean>>;
  }) => {
    await axios.put(
      `/products/big-hearts-packages/my-orders/${userPackage.orderId}/cancel`
    );

    setIsCancelModalOpen(false);

    return userPackage.orderId;
  }
);

export enum OrderTypes {
  ORDER = 1,
  PACKAGE = 2,
  LICENCE = 3,
  COMBO = 4,
  TICKETS = 5
}

export interface accountingSliceType {
  loading: boolean;
  orders: MyOrderListModel[];
}

const initialState = {
  loading: false,
  orders: []
} as accountingSliceType;

const ordersSlice = createSlice({
  name: 'orders',
  initialState,
  reducers: {
    removeOrdersState(state) {
      state = initialState;
    }
  },

  extraReducers: (builder) => {
    builder.addCase(getOrders.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getOrders.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.orders = payload;
    });
    builder.addCase(getOrders.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(cancelOrder.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(cancelOrder.fulfilled, (state, { payload }) => {
      state.loading = false;
      const index = state.orders.findIndex((p) => p.orderId === payload);
      state.orders[index].status = 4;
    });
    builder.addCase(cancelOrder.rejected, (state) => {
      state.loading = false;
    });
  }
});

export const { removeOrdersState } = ordersSlice.actions;

export default ordersSlice.reducer;
